var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('button',{on:{"click":function($event){return _vm.$emit('onSelect')}}},[_vm._v(_vm._s(_vm.isAlive ? '👶' : '⚱️'))]),(_vm.isSelected)?_c('span',[_vm._v(_vm._s(_vm.number))]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }